var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('consultations-and-reworks-grid',{attrs:{"items":_vm.items,"total":_vm.total,"loading":_vm.loading,"count-of-debts":_vm.countOfDebts,"sum-of-academic-hours-debts":_vm.sumOfAcademicHoursDebts},on:{"paginate":_vm.onPaginate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }